export default "__VITE_ASSET__BU3pKv7c__"